import { GraphQLResult, generateClient } from "aws-amplify/api";
// @ts-ignore
import { batchGetRevisionsByFieldInstance } from "../graphql/queries";
import { recordSentry } from "utils/recordSentry";
import { Revision } from "db/definitions";

/**
 * Gets all the revisions by the field instance id.
 * @param fieldInstanceId FieldInstance the revision is related to.
 * @returns revisions
 */
async function batchRetrieveRevisions(fieldInstanceId: string): Promise<Revision[]> {
	try {
		const items = [];
		let nextToken;
		while (nextToken !== null) {
			// REtrieve by field instance here
			interface QueryResponse {
				revisionsByFieldInstance: {
					items: Revision[];
					nextToken: string | null;
				};
			}
			const client = generateClient({ authMode: "userPool" });
			const result = (await client.graphql({
				query: batchGetRevisionsByFieldInstance,
				variables: { fieldInstanceId, nextToken },
				authMode: "userPool",
			})) as GraphQLResult<QueryResponse>;

			const revisionArray = result.data.revisionsByFieldInstance.items;
			for (const revision of revisionArray) {
				items.push(revision);
			}
			nextToken = result.data.revisionsByFieldInstance.nextToken;
		}
		return items;
	} catch (error) {
		recordSentry({ error });
	}
	return [];
}

export default batchRetrieveRevisions;
